import React from "react";
import {
  Checkbox,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  Select,
  Typography, withStyles
} from "@material-ui/core";

const styles = (theme) => ({
  configurator:{
    background: '#dbdbdb',
    padding: 20,
    position: "fixed",
    width: '100%',
    top: 0,
    zIndex: 1,
  },
  portfolioConfigBlockInnerGridContainer: {
    height: theme.wbiComponent.portfolioConfigBlock.height,
    padding: "0 20px",
  },
  formGroup: {
    flexDirection: "row",
    "& label": {
      [theme.breakpoints.down("md")]: {
        width: "100%",
      },
    },
  },
  radioBase: {
    width: 34,
    height: 34,
    [theme.breakpoints.down("md")]: {
      height: 24,
    },
    marginLeft: 6,
    "& svg": {
      [theme.breakpoints.down("md")]: {
        fontSize: 17,
      },
    },
  },

  settingsText: {
    float: "left",
    color: theme.palette.secondary.charcoal,
    fontSize: 14,
    fontWeight: 500,
    [theme.breakpoints.down("md")]: {
      fontSize: 13,
    },
  },
  settingsTextMain: {
    fontSize: 14,
    color: theme.palette.secondary.charcoal,
    fontWeight: 500,
  },

  checkbox: {
    width: 24,
    height: 24,
    padding: 0,
    marginRight: 10,
    float: "left",
    "& svg": {
      fontSize: 19,
    },
  },
  smallSelect: {
    fontSize: 14,
  },
  riskCheckbox: {
    [theme.breakpoints.down("md")]: {
      marginLeft: "-5px !important",
    },
    "& h3": {
      [theme.breakpoints.down("md")]: {
        paddingTop: "3px",
      },
    },
  },
  includeCheckbox: {
    "& h3": {
      [theme.breakpoints.down("md")]: {
        paddingTop: "3px",
      },
    },
    "&.visually-hidden": {
      visibility: "hidden",
    },
  }
});

const StrategyConfigurator = ({
  classes,
  appName = 'Cy',
  wbiStrategyList = [],
  strategyParam,
  handleStrategyParamChange,
  managerTypeList
}) => {
  const {
    solveFor,
    managerType,
    includeTheoretical,
    rror,
    riskTolerance,
    riskPeriod,
    singleStrategy
  } = strategyParam;

  return <section className={classes.configurator}>
    <Grid
      container
      alignItems={"center"}
    >
      <Grid item xs={2}>
        <Typography
          variant="subtitle1"
          className={classes.settingsText}
        >
          Solve For
        </Typography>
        <br />
        {['WBI Portfolios', 'WBI Envestnet', 'Other Models'].includes(managerType) ? (
          <RadioGroup
            className={classes.formGroup}
            aria-label="Solve For"
            name="solveFor"
            value={null}
          >
            <FormControlLabel
              style={{ marginRight: 10 }}
              value="ret"
              control={
                <Radio
                  className={classes.radioBase}
                  color={"primary"}
                  disabled
                />
              }
              label="Return"
            />
            <FormControlLabel
              style={{ marginRight: 10 }}
              value="risk"
              control={
                <Radio
                  className={classes.radioBase}
                  color={"primary"}
                  disabled
                />
              }
              label="Risk"
            />
          </RadioGroup>
        ) : (
          <RadioGroup
            className={classes.formGroup}
            aria-label="Solve For"
            name="solveFor"
            value={solveFor}
            onChange={(e) =>
              handleStrategyParamChange("solveFor", false, e)
            }
          >
            <FormControlLabel
              style={{ marginRight: 10 }}
              value="ret"
              control={
                <Radio
                  className={classes.radioBase}
                  color={"primary"}
                />
              }
              label="Return"
            />
            <FormControlLabel
              style={{ marginRight: 10 }}
              value="risk"
              control={
                <Radio
                  className={classes.radioBase}
                  color={"primary"}
                />
              }
              label="Risk"
            />
          </RadioGroup>
        )}
      </Grid>
      <Grid item xs={2}>
        {solveFor === "ret" && (
          <React.Fragment>
            <Typography
              variant="h5"
              className={classes.settingsTextMain}
            >
              Target Return
            </Typography>
            {['WBI Portfolios', 'WBI Envestnet', 'Other Models'].includes(managerType) ? (
              <Select
                native
                value={""}
                inputProps={{ name: "rror" }}
                className={classes.smallSelect}
                disabled
                style={{ minWidth: 80 }}
              >
                <option value={""} />
              </Select>
            ) : (
              <Select
                native
                value={rror}
                onChange={(e) =>
                  handleStrategyParamChange("rror", false, e)
                }
                inputProps={{ name: "rror" }}
                className={classes.smallSelect}
              >
                {managerType === "401k" ? (
                  <React.Fragment>
                    <option value="0.06">6.00%</option>
                    <option value="0.08">8.00%</option>
                    <option value="0.1">10.00%</option>
                    <option value="0.12">12.00%</option>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <option value="0.05">5.00%</option>
                    <option value="0.06">6.00%</option>
                    <option value="0.07">7.00%</option>
                    <option value="0.08">8.00%</option>
                    <option value="0.09">9.00%</option>
                    <option value="0.1">10.00%</option>
                    <option value="0.11">11.00%</option>
                    <option value="0.12">12.00%</option>
                    <option value="0.13">13.00%</option>
                    <option value="0.14">14.00%</option>
                    <option value="0.15">15.00%</option>
                  </React.Fragment>
                )}
              </Select>
            )}
          </React.Fragment>
        )}
        {solveFor === "risk" && (
          <React.Fragment>
            {/* TODO: change it to classes*/}
            <Typography
              variant="h5"
              className={classes.settingsTextMain}
            >
              Loss Tolerance
            </Typography>
            <Select
              native
              value={riskTolerance}
              onChange={(e) =>
                handleStrategyParamChange("riskTolerance", false, e)
              }
              inputProps={{
                name: "riskTolerance",
              }}
              className={classes.smallSelect}
              disabled={['WBI Portfolios', 'WBI Envestnet', 'Other Models'].includes(managerType)}
            >
              <option value="-0.05">-5.00%</option>
              <option value="-0.1">-10.00%</option>
              <option value="-0.15">-15.00%</option>
              <option value="-0.2">-20.00%</option>
              {managerType !== "401k" && (
                <option value="-0.25">-25.00%</option>
              )}
              <option value="-0.3">-30.00%</option>
              {managerType !== "401k" && (
                <option value="-0.35">-35.00%</option>
              )}
              <option value="-0.4">-40.00%</option>
            </Select>
          </React.Fragment>
        )}
      </Grid>

      <Grid item xs={2}>
        <Typography
          variant="subtitle1"
          className={classes.settingsText}
        >
          Manager Type
        </Typography>
        <br />
        <Select
          native
          className={classes.smallSelect}
          value={managerType}
          onChange={(e) =>
            handleStrategyParamChange("managerType", false, e)
          }
          inputProps={{
            name: "managerType",
          }}
        >
          {
            managerTypeList.map((m) => (<option key={m.code} value={m.code}>{m.name}</option>))
          }
        </Select>
      </Grid>
      <Grid item xs={2}>
        {/*Risk Selection*/}
        <Typography
          variant="subtitle1"
          className={classes.settingsText}
        >
          Risk Selection
        </Typography>
        <br />
        <Select
          native
          className={classes.smallSelect}
          value={riskPeriod}
          onChange={(e) =>
            handleStrategyParamChange("riskPeriod", false, e)
          }
          inputProps={{
            name: "riskPeriod",
          }}
          disabled={managerType === "401k"}
        >
          <option value="mdd">Worst Drawdown</option>
          <option value="worst.calendar.year">
            Worst Calendar Year
          </option>
          <option value="worst.4q">Worst Four Quarters</option>
        </Select>
      </Grid>
      {['WBI Portfolios', 'WBI Envestnet', 'Other Models'].includes(managerType) ? (
        <Grid item xs={4}>
          {/*Portfolio*/}
          <Typography
            variant="subtitle1"
            className={classes.settingsText}
          >
            Portfolio
          </Typography>
          <br />
          <Select
            native
            className={classes.smallSelect}
            value={singleStrategy}
            onChange={(e) =>
              handleStrategyParamChange("singleStrategy", false, e)
            }
            inputProps={{
              name: "singleStrategy",
            }}
          >
            {wbiStrategyList.map((s) => (
              <option
                value={s.strategyScenario}
                key={s.strategyScenario}
              >
                {s.strategyName}
              </option>
            ))}
          </Select>
        </Grid>
      ) : (
        <Grid item xs={2}>
          <div className={`${classes.includeCheckbox}`}>
            {/*Include Back-Tested*/}
            <Typography
              variant="subtitle1"
              className={classes.settingsText}
            >
              Back-Tested
            </Typography>
            <br />
            <label>
              <Checkbox
                className={classes.checkbox}
                checked={includeTheoretical}
                onChange={(e) =>
                  handleStrategyParamChange(
                    "includeTheoretical",
                    true,
                    e
                  )
                }
                color="primary"
                disabled={!!managerTypeList.filter(m => m.allowBackTested === false).find(m => m.code === managerType)}
              />
              <Typography
                variant="subtitle1"
                className={classes.settingsText}
              >
                Include
              </Typography>
            </label>
          </div>
        </Grid>
      )}
    </Grid>
  </section>
}


export default withStyles(styles)(StrategyConfigurator);


// WEBPACK FOOTER //
// ./src/containers/CprTest/components/StrategyConfigurator.jsx